<div class="main-content">
  <div class="container-fluid">
    <form-summary [data]="dataEpe" [report]="true"></form-summary>
    <form-summary [data]="dataProject" [report]="false"></form-summary>
  </div>
</div>
